import { truckingRateConstants } from '../../_constants';
import { truckingRateServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const truckingRateActions = {
    getAllTruckingRates,
    getTruckingRates,
    createTruckingRate,
    updateTruckingRate,
    getTruckingRateById,
    deleteTruckingRates,
    activation,
    searchTruckingRates,
    getTruckingRateListByCode,
    truckingGroupByChargeCode,
    truckingReadGroupCharge,
    truckingReadGroupBranchCharge,
};

function truckingRateFetching() { return { type: truckingRateConstants.TRUCKING_RATE_FETCHING } }
function truckingRateFetched() { return { type: truckingRateConstants.TRUCKING_RATE_FETCHED } }

function getAllTruckingRates() {
    return dispatch => {
        truckingRateServices.getAllTruckingRates()
            .then(
                truckingRates => dispatch(success(truckingRates)),
                error => dispatch(alertActions.error(error.toString()))
            );
    };
    function success(truckingRates) { return { type: truckingRateConstants.GET_ALL_TRUCKING_RATES, truckingRates } }
}

function getTruckingRates(skip, take, search, filter) {
    return dispatch => {
        dispatch(truckingRateFetching());
        dispatch(userActions.allowLeavePage());
        truckingRateServices.getTruckingRates(skip, take, search, filter)
            .then(
                truckingRates => {
                    if (truckingRates.length > 0) {
                        dispatch(success(truckingRates));
                        dispatch(truckingRateFetched());
                    } else {
                        dispatch(truckingRateFetched());
                        dispatch(alertActions.warning(truckingRates.message))
                    }
                },
                error => {
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(truckingRates) { return { type: truckingRateConstants.GET_TRUCKING_RATES, truckingRates } }
}

function createTruckingRate(truckingRate, userProfile) {
    return dispatch => {
        dispatch(truckingRateFetching());
        dispatch(userActions.notallowLeavePage());
        truckingRateServices.createTruckingRate(truckingRate, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.success('Trucking rate added successfully'))
                    window.location.href = '/master_data/Trucking_rate';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function updateTruckingRate(truckingRate, userProfile) {
    return dispatch => {
        dispatch(updateTruckingRate(truckingRate));
        dispatch(userActions.notallowLeavePage());
        truckingRateServices.updateTruckingRate(truckingRate, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Trucking rate updated successfully'))
                    window.location.href = '/master_data/Trucking_rate';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function updateTruckingRate() { return { type: truckingRateConstants.UPDATE_TRUCKING_RATE } }
}

function getTruckingRateById(id) {
    return dispatch => {
        dispatch(truckingRateFetching());
        dispatch(userActions.allowLeavePage());
        truckingRateServices.getTruckingRateById(id)
            .then(
                truckingRate => {
                    dispatch(success(truckingRate))
                    dispatch(truckingRateFetched());
                },
                error => {
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(truckingRate) { return { type: truckingRateConstants.GET_TRUCKING_RATE_BY_ID, truckingRate } }
}

function deleteTruckingRates(id, type, take) {
    return dispatch => {
        dispatch(truckingRateFetching());
        dispatch(userActions.notallowLeavePage());
        truckingRateServices.deleteTruckingRates(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingRateFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Trucking rates deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/Trucking_rate';
                            break;
                        default:
                            window.location.href = '/master_data/Trucking_rate';
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingRateFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                    switch (type) {
                        case "specific":
                            dispatch(getTruckingRateById(id));
                            break;
                        default:
                            window.location.href = '/master_data/Trucking_rate';
                            break;
                    }
                }
            );
    };
}

function activation(area, charge, port, id, isActive) {
    return dispatch => {
        dispatch(truckingRateFetching());
        dispatch(userActions.notallowLeavePage());
        truckingRateServices.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingRateFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getTruckingRateListByCode(area, charge, port));
                    dispatch(alertActions.success(isActive ? 'Trucking rate activated successfully' : 'Trucking rate deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
}

function searchTruckingRates(take, filter, search) {
    return dispatch => {
        dispatch(truckingRateFetching());
        truckingRateServices.searchTruckingRates(take, filter, search)
            .then(
                truckingRates => dispatch(searchTruckingRates(truckingRates)),
                error => {
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function searchTruckingRates(truckingRates) { return { type: truckingRateConstants.SEARCH_TRUCKING_RATES, truckingRates } }
}

function getTruckingRateListByCode(charge, port, area) {
    return dispatch => {
        dispatch(truckingRateFetching());
        dispatch(userActions.allowLeavePage());
        truckingRateServices.getTruckingRateListByCode(charge, port, area)
            .then(
                truckingRate => {
                    dispatch(success(truckingRate))
                    dispatch(truckingRateFetched());
                },
                error => {
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(truckingRate) { return { type: truckingRateConstants.GET_TRUCKING_RATE_BY_ID, truckingRate } }
}

function truckingGroupByChargeCode() {
    return dispatch => {
        dispatch(truckingRateFetching());
        dispatch(userActions.allowLeavePage());
        truckingRateServices.truckingGroupByChargeCode()
            .then(
                truckingRateCharges => {
                    dispatch(success(truckingRateCharges))
                    dispatch(truckingRateFetched());
                },
                error => {
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(truckingRateCharges) { return { type: truckingRateConstants.TRUCKINGRATE_GROUP_BY_CHARGE, truckingRateCharges } }
}

function truckingReadGroupCharge(charge, skip, take, search) {
    return dispatch => {
        dispatch(truckingRateFetching());
        dispatch(userActions.allowLeavePage());
        truckingRateServices.truckingReadGroupCharge(charge, skip, take, search)
            .then(
                truckingRateGroupCharge => {
                    if (truckingRateGroupCharge.length > 0) {
                        dispatch(success(truckingRateGroupCharge));
                        dispatch(truckingRateFetched());
                    } else {
                        dispatch(alertActions.warning(truckingRateGroupCharge.message))
                        dispatch(truckingRateFetched());
                    }
                },
                error => {
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(truckingRateGroupCharge) { return { type: truckingRateConstants.TRUCKINGRATE_GROUP_CHARGE, truckingRateGroupCharge } }
}

function truckingReadGroupBranchCharge(charge, branch, skip, take, search) {
    return dispatch => {
        dispatch(truckingRateFetching());
        dispatch(userActions.allowLeavePage());
        truckingRateServices.truckingReadGroupBranchCharge(charge, branch, skip, take, search)
            .then(
                truckingRates => {
                    if (truckingRates.length > 0) {
                        dispatch(success(truckingRates));
                        dispatch(truckingRateFetched());
                    } else {
                        dispatch(alertActions.warning(truckingRates.message))
                        dispatch(truckingRateFetched());
                    }
                },
                error => {
                    dispatch(truckingRateFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };
    function success(truckingRates) { return { type: truckingRateConstants.TRUCKINGRATE_GROUP_BRANCH_CHARGE, truckingRates } }
}